module.exports = __webpack_public_path__ + "img/fish.f8490eb1.png";